import { useRouter } from 'next/router';
import { useMemo, useState } from 'react';
import { Order } from '~/@types/table/order';
import { ASC_SORTED_COLUMNS } from '../constants';

export type SortProps = {
  createSortHandler(property: string): (event: React.MouseEvent<unknown>) => void;
  order: Order;
  orderBy: string;
  sortField: string;
};

type Args = {
  orderField: string;
  resetPage?: () => void;
};

const useSort = ({ orderField, resetPage }: Args): SortProps => {
  const router = useRouter();
  const { orderField: savedOrderBy, order: savedOrder } = router.query;

  const [order, setOrder] = useState<Order>((savedOrder as Order) || 'desc');
  const [orderBy, setOrderBy] = useState<string>((savedOrderBy as string) || orderField || '');

  const newOrder = (property: string) => {
    if (!!property && orderBy === property) {
      return order === 'asc' ? 'desc' : 'asc';
    } else {
      return ASC_SORTED_COLUMNS.includes(property) ? 'asc' : 'desc';
    }
  };

  const sortField = useMemo(() => {
    switch (orderBy) {
      case undefined:
        return '';
      case 'borrower_name_1':
        return 'borrower_1_last_name';
      case 'borrower_name_2':
        return 'borrower_2_last_name';
      case 'borrower_name_3':
        return 'borrower_3_last_name';
      case 'borrower_name_4':
        return 'borrower_4_last_name';
      default:
        return orderBy;
    }
  }, [orderBy]);

  const handleRequestSort = (_event: React.MouseEvent<unknown>, property: string) => {
    !!resetPage && resetPage();
    setOrder(newOrder(property));
    setOrderBy(property);
  };

  const createSortHandler = (property: string) => (event: React.MouseEvent<unknown>) => {
    handleRequestSort(event, property);
  };

  return {
    createSortHandler,
    order,
    orderBy,
    sortField,
  };
};

export default useSort;
